@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-1">
        @if ($previousDocuments().length > 0 && $currentUser().isPublicAgent) {
            <!-- Task body: visão do executor -->
            <div class="message-container">
                <div>Conteúdo para encaminhamento:</div>
                <div class="documents-container">
                    @for (doc of $previousDocuments(); track doc) {
                        <div class="position-relative my-1">
                            <span class="document-highlight" (click)="openDocumentModal(doc.id)" (keyDown)="openDocumentModal(doc.id)">
                                <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do documento">{{doc.registro}}</span>
                                <span class="info-font d-inline-block" matTooltip="Clique para visualizar o documento que foi capturado no E-Docs">
                                    <i class="fas fa-external-link-alt mr-1"></i><u>{{doc.filename}}</u>
                                </span>
                            </span>
                        </div>
                    }
                </div>
                <hr />
            </div>
        }

        <!-- Task info: Realizada -->
        <div class="message-container">
            <div class="mb-3">
                O conteúdo disponível no protocolo E-Docs
                <span class="info-font text-highlight">{{$protocolo()}}</span>
                foi encaminhado para<b>{{$configSchema()?.taskForward.toImmediateSupervisor == true ? ' o gestor imediato' : ''}}</b>:
            </div>
            <div>
                <span class="uppercase info-font text-highlight d-inline-block">{{$inputData()?.recipientName}}</span>
            </div>
        </div>
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
